import { Component, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';

export interface AddClinicianNoteData {
    existingNotes: string;
    orderId?: number;
    dialogTitle?: string;
    quickSuggestions?: Array<{ value: string; label: string }>;
}

@Component({
    selector: 'app-add-clinician-note',
    templateUrl: './add-clinician-note.component.html',
    styleUrls: ['./add-clinician-note.component.scss'],
    standalone: false
})
export class AddClinicianNoteComponent {
    newNote: UntypedFormControl = new UntypedFormControl('', [Validators.required]);
    dialogTitle: string = 'Add Note';

    allClinicianNoteOptions = [
        { value: 'check_results', label: 'Check results' },
        { value: 'additional_info', label: 'Additional information added - please check' },
        { value: 'waiting_on_additional_info', label: 'Waiting on additional information' }
    ];

    quickSuggestions = [];

    constructor(
        private dialogRef: MatDialogRef<AddClinicianNoteComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AddClinicianNoteData,
        private jwtAuth: JwtAuthService
    ) {
        // Use provided title or set default based on suggestions
        if (this.data.dialogTitle) {
            this.dialogTitle = this.data.dialogTitle;
        } else if (this.data.quickSuggestions && this.data.quickSuggestions.length > 0) {
            this.dialogTitle = 'Add Note';
        } else {
            // Default clinician note behavior
            if (this.jwtAuth.isClinician()) {
                this.dialogTitle = 'Add Note';
            } else {
                this.dialogTitle = 'Add Quick Note to Clinician';
            }
        }

        // Use provided suggestions or filter default clinician suggestions based on role
        if (this.data.quickSuggestions) {
            this.quickSuggestions = this.data.quickSuggestions;
        } else {
            // Default clinician note behavior: filter based on user role
            if (this.jwtAuth.isClinician()) {
                this.quickSuggestions = this.allClinicianNoteOptions.filter(
                    opt => opt.value === 'waiting_on_additional_info'
                );
            } else {
                this.quickSuggestions = this.allClinicianNoteOptions.filter(
                    opt => opt.value !== 'waiting_on_additional_info'
                );
            }
        }
    }

    useSuggestion(suggestionLabel: string) {
        this.newNote.setValue(suggestionLabel);
    }

    onNoClick() {
        this.dialogRef.close();
    }

    onSubmit() {
        this.dialogRef.close(this.newNote.value);
    }
}
